import i18n from 'i18next';
import { providerCheckHandler } from 'globalutils/tenant/providerCheckHandler';
import { SERVICE_PROVIDERS } from '@/config/tenants/global';

// provider and SERVICE_PROVIDERS[key] will be same
const getProviderCheck = ({ parent }) => {
  return {
    render_location_label: {
      [SERVICE_PROVIDERS.TP]: () => i18n.t('fuelConsumption.JurisdictionLocation'),
      default: () => i18n.t('fuelConsumption.Jurisdiction'),
    },
    render_location_plaveholder: {
      [SERVICE_PROVIDERS.TP]: () => i18n.t('fuelConsumption.JurisdictionLocation'),
      default: () => i18n.t('fuelConsumption.Jurisdiction'),
    },
    render_jurisdiction_label: {
      [SERVICE_PROVIDERS.TP]: () => i18n.t('fuelConsumption.JurisdictionLocation'),
      default: () => i18n.t('fuelConsumption.Jurisdiction'),
    },
    render_jurisdiction_plaveholder: {
      [SERVICE_PROVIDERS.TP]: () => i18n.t('fuelConsumption.JurisdictionLocation'),
      default: () => i18n.t('fuelConsumption.Jurisdiction'),
    },
    default: () => true,
  };
};

export const checkServiceProvider = (key, provider, def = true, params = {}) =>
  providerCheckHandler({ key, provider, def, params }, getProviderCheck);
